// app/redux/reducers/demandesReducer.js

import {
    // common
    SET_DEMANDE_LOADING,
    CLEAR_DEMANDE_MESSAGE,
    CLEAR_DEMANDE_TRACKING,

    // lists
    GET_MY_DEMANDES_REQUEST,
    GET_MY_DEMANDES_SUCCESS,
    GET_MY_DEMANDES_FAIL,
    GET_MY_FORMATION_DEMANDES_REQUEST,
    GET_MY_FORMATION_DEMANDES_SUCCESS,
    GET_MY_FORMATION_DEMANDES_FAIL,

    GET_CREATED_BY_ME_DEMANDES_REQUEST,
    GET_CREATED_BY_ME_DEMANDES_SUCCESS,
    GET_CREATED_BY_ME_DEMANDES_FAIL,
    GET_DEMANDE_TRACKING_REQUEST,
    GET_DEMANDE_TRACKING_SUCCESS,
    GET_DEMANDE_TRACKING_FAIL,

    // create (3 modes)
    CREATE_DEMANDE_COLLAB_REQUEST,
    CREATE_DEMANDE_COLLAB_SUCCESS,
    CREATE_DEMANDE_COLLAB_FAIL,
    CREATE_EVENT_DEMANDE_BY_LEARNER_REQUEST,
    CREATE_EVENT_DEMANDE_BY_LEARNER_SUCCESS,
    CREATE_EVENT_DEMANDE_BY_LEARNER_FAIL,
    CANCEL_EVENT_DEMANDE_REQUEST,
    CANCEL_EVENT_DEMANDE_SUCCESS,
    CANCEL_EVENT_DEMANDE_FAIL,
    WITHDRAW_EVENT_DEMANDE_REQUEST,
    WITHDRAW_EVENT_DEMANDE_SUCCESS,
    WITHDRAW_EVENT_DEMANDE_FAIL,

    CREATE_DEMANDE_MANAGER_REQUEST,
    CREATE_DEMANDE_MANAGER_SUCCESS,
    CREATE_DEMANDE_MANAGER_FAIL,
    CREATE_EVENT_DEMANDE_BY_MANAGER_REQUEST,
    CREATE_EVENT_DEMANDE_BY_MANAGER_SUCCESS,
    CREATE_EVENT_DEMANDE_BY_MANAGER_FAIL,

    CREATE_DEMANDE_RF_REQUEST,
    CREATE_DEMANDE_RF_SUCCESS,
    CREATE_DEMANDE_RF_FAIL,
    CREATE_EVENT_DEMANDE_BY_RF_REQUEST,
    CREATE_EVENT_DEMANDE_BY_RF_SUCCESS,
    CREATE_EVENT_DEMANDE_BY_RF_FAIL,

    // bulk
    CREATE_DEMANDE_MANAGER_BULK_REQUEST,
    CREATE_DEMANDE_MANAGER_BULK_SUCCESS,
    CREATE_DEMANDE_MANAGER_BULK_FAIL,

    CREATE_DEMANDE_RF_BULK_REQUEST,
    CREATE_DEMANDE_RF_BULK_SUCCESS,
    CREATE_DEMANDE_RF_BULK_FAIL,

    // inbox
    GET_DEMANDE_MANAGER_INBOX_REQUEST,
    GET_DEMANDE_MANAGER_INBOX_SUCCESS,
    GET_DEMANDE_MANAGER_INBOX_FAIL,
    GET_DEMANDES_MANAGER_CAMPAGNE_REQUEST,
    GET_DEMANDES_MANAGER_CAMPAGNE_SUCCESS,
    GET_DEMANDES_MANAGER_CAMPAGNE_FAIL,

    GET_DEMANDE_RF_INBOX_REQUEST,
    GET_DEMANDE_RF_INBOX_SUCCESS,
    GET_DEMANDE_RF_INBOX_FAIL,
    GET_DEMANDES_CAMPAGNE_REQUEST,
    GET_DEMANDES_CAMPAGNE_SUCCESS,
    GET_DEMANDES_CAMPAGNE_FAIL,

    // decisions
    DEMANDE_MANAGER_DECISION_REQUEST,
    DEMANDE_MANAGER_DECISION_SUCCESS,
    DEMANDE_MANAGER_DECISION_FAIL,

    DEMANDE_RF_DECISION_REQUEST,
    DEMANDE_RF_DECISION_SUCCESS,
    DEMANDE_RF_DECISION_FAIL, GET_COMPANY_DEMANDES_SUCCESS, GET_COMPANY_DEMANDES_FAIL,
    FETCH_PARTICIPATION_CAMPAGNE_REQUEST,
    FETCH_PARTICIPATION_CAMPAGNE_SUCCESS,
    FETCH_PARTICIPATION_CAMPAGNE_FAIL,
    RELANCE_WORKFLOW_DEMANDE_REQUEST,
    RELANCE_WORKFLOW_DEMANDE_SUCCESS,
    RELANCE_WORKFLOW_DEMANDE_FAIL,
    RELANCE_WORKFLOW_CAMPAGNE_REQUEST,
    RELANCE_WORKFLOW_CAMPAGNE_SUCCESS,
    RELANCE_WORKFLOW_CAMPAGNE_FAIL,
    PROLONGER_CAMPAGNE_REQUEST,
    PROLONGER_CAMPAGNE_SUCCESS,
    PROLONGER_CAMPAGNE_FAIL,
    RELANCE_PARTICIPATION_CAMPAGNE_REQUEST,
    RELANCE_PARTICIPATION_CAMPAGNE_SUCCESS,
    RELANCE_PARTICIPATION_CAMPAGNE_FAIL,
} from "../actions/demandesActions";

const initialState = {
    loading: false,

    // messages / errors (affichage UI)
    message: null,
    error: null,

    // data
    myDemandes: [],
    myFormationDemandes: [],
    createdByMeDemandes: [],

    managerInbox: [],
    rfInbox: [],
    companyDemandes: [], // NEW
    selectedDemandeTracking: null,
    demandeTrackingById: {},
    loadingTracking: false,
    trackingError: null,
    participationByCampagneId: {},
    loadingParticipation: false,
    loadingRelance: false,
    loadingProlongation: false,
    errors: {},

    // last actions outputs (optionnel)
    lastCreated: null,
    lastBulkCreated: [],
    lastManagerDecision: null,
    lastRfDecision: null,
};

export default function demandesReducer(state = initialState, action) {
    switch (action.type) {
        // =====================
        // COMMON
        // =====================

        case GET_COMPANY_DEMANDES_SUCCESS:
            return { ...state, companyDemandes: action.payload || [], error: null };

        case GET_COMPANY_DEMANDES_FAIL:
            return { ...state, error: action.payload };
        case FETCH_PARTICIPATION_CAMPAGNE_REQUEST:
            return { ...state, loadingParticipation: true, error: null, errors: { ...state.errors, participation: null } };
        case FETCH_PARTICIPATION_CAMPAGNE_SUCCESS:
            return {
                ...state,
                loadingParticipation: false,
                participationByCampagneId: {
                    ...state.participationByCampagneId,
                    [String(action.payload?.campagneId)]: action.payload?.data,
                },
                error: null,
            };
        case FETCH_PARTICIPATION_CAMPAGNE_FAIL:
            return {
                ...state,
                loadingParticipation: false,
                error: action.payload,
                errors: { ...state.errors, participation: action.payload },
            };
        case RELANCE_WORKFLOW_DEMANDE_REQUEST:
        case RELANCE_WORKFLOW_CAMPAGNE_REQUEST:
        case RELANCE_PARTICIPATION_CAMPAGNE_REQUEST:
            return { ...state, loadingRelance: true, error: null, errors: { ...state.errors, relance: null } };
        case RELANCE_WORKFLOW_DEMANDE_SUCCESS:
        case RELANCE_WORKFLOW_CAMPAGNE_SUCCESS:
        case RELANCE_PARTICIPATION_CAMPAGNE_SUCCESS:
            return { ...state, loadingRelance: false, message: action.payload?.message || "Relance envoyée", error: null };
        case RELANCE_WORKFLOW_DEMANDE_FAIL:
        case RELANCE_WORKFLOW_CAMPAGNE_FAIL:
        case RELANCE_PARTICIPATION_CAMPAGNE_FAIL:
            return {
                ...state,
                loadingRelance: false,
                error: action.payload,
                errors: { ...state.errors, relance: action.payload },
            };
        case PROLONGER_CAMPAGNE_REQUEST:
            return { ...state, loadingProlongation: true, error: null, errors: { ...state.errors, prolongation: null } };
        case PROLONGER_CAMPAGNE_SUCCESS:
            return { ...state, loadingProlongation: false, message: "Campagne prolongée", error: null };
        case PROLONGER_CAMPAGNE_FAIL:
            return {
                ...state,
                loadingProlongation: false,
                error: action.payload,
                errors: { ...state.errors, prolongation: action.payload },
            };
        case SET_DEMANDE_LOADING:
            return {
                ...state,
                loading: !!action.payload,
            };

        case CLEAR_DEMANDE_MESSAGE:
            return {
                ...state,
                message: null,
                error: null,
            };

        case CLEAR_DEMANDE_TRACKING:
            return {
                ...state,
                selectedDemandeTracking: null,
                loadingTracking: false,
                trackingError: null,
            };

        // =====================
        // LISTS - MY
        // =====================
        case GET_MY_DEMANDES_REQUEST:
            return {
                ...state,
                error: null,
            };

        case GET_MY_DEMANDES_SUCCESS:
            return {
                ...state,
                myDemandes: Array.isArray(action.payload) ? action.payload : [],
                error: null,
            };

        case GET_MY_DEMANDES_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur chargement demandes",
            };

        case GET_MY_FORMATION_DEMANDES_REQUEST:
            return {
                ...state,
                error: null,
            };

        case GET_MY_FORMATION_DEMANDES_SUCCESS:
            return {
                ...state,
                myFormationDemandes: Array.isArray(action.payload) ? action.payload : [],
                error: null,
            };

        case GET_MY_FORMATION_DEMANDES_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur chargement demandes de formation",
            };

        // =====================
        // LISTS - CREATED BY ME
        // =====================
        case GET_CREATED_BY_ME_DEMANDES_REQUEST:
            return {
                ...state,
                error: null,
            };

        case GET_CREATED_BY_ME_DEMANDES_SUCCESS:
            return {
                ...state,
                createdByMeDemandes: Array.isArray(action.payload) ? action.payload : [],
                error: null,
            };

        case GET_CREATED_BY_ME_DEMANDES_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur chargement demandes (créées par moi)",
            };

        case GET_DEMANDE_TRACKING_REQUEST:
            return {
                ...state,
                loadingTracking: true,
                trackingError: null,
                selectedDemandeTracking: null,
            };

        case GET_DEMANDE_TRACKING_SUCCESS:
            return {
                ...state,
                loadingTracking: false,
                trackingError: null,
                selectedDemandeTracking: action.payload?.data || null,
                demandeTrackingById: {
                    ...state.demandeTrackingById,
                    [String(action.payload?.demandeId)]: action.payload?.data || null,
                },
            };

        case GET_DEMANDE_TRACKING_FAIL:
            return {
                ...state,
                loadingTracking: false,
                trackingError: action.payload || "Erreur chargement suivi",
            };

        // =====================
        // CREATE (3 MODES)
        // =====================
        case CREATE_DEMANDE_COLLAB_REQUEST:
        case CREATE_DEMANDE_MANAGER_REQUEST:
        case CREATE_DEMANDE_RF_REQUEST:
        case CREATE_EVENT_DEMANDE_BY_LEARNER_REQUEST:
        case CREATE_EVENT_DEMANDE_BY_MANAGER_REQUEST:
        case CREATE_EVENT_DEMANDE_BY_RF_REQUEST:
        case CANCEL_EVENT_DEMANDE_REQUEST:
        case WITHDRAW_EVENT_DEMANDE_REQUEST:
            return {
                ...state,
                error: null,
                message: null,
                lastCreated: null,
            };

        case CREATE_DEMANDE_COLLAB_SUCCESS:
        case CREATE_DEMANDE_MANAGER_SUCCESS:
        case CREATE_DEMANDE_RF_SUCCESS:
        case CREATE_EVENT_DEMANDE_BY_LEARNER_SUCCESS:
        case CREATE_EVENT_DEMANDE_BY_MANAGER_SUCCESS:
        case CREATE_EVENT_DEMANDE_BY_RF_SUCCESS:
        case CANCEL_EVENT_DEMANDE_SUCCESS:
        case WITHDRAW_EVENT_DEMANDE_SUCCESS:
            return {
                ...state,
                lastCreated: action.payload || null,
                message:
                    action.type === CANCEL_EVENT_DEMANDE_SUCCESS
                        ? "Demande annulée"
                        : action.type === WITHDRAW_EVENT_DEMANDE_SUCCESS
                            ? "Désistement enregistré"
                            : "Demande créée",
                error: null,
            };

        case CREATE_DEMANDE_COLLAB_FAIL:
        case CREATE_DEMANDE_MANAGER_FAIL:
        case CREATE_DEMANDE_RF_FAIL:
        case CREATE_EVENT_DEMANDE_BY_LEARNER_FAIL:
        case CREATE_EVENT_DEMANDE_BY_MANAGER_FAIL:
        case CREATE_EVENT_DEMANDE_BY_RF_FAIL:
        case CANCEL_EVENT_DEMANDE_FAIL:
        case WITHDRAW_EVENT_DEMANDE_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur création demande",
                message: null,
            };

        // =====================
        // BULK
        // =====================
        case CREATE_DEMANDE_MANAGER_BULK_REQUEST:
        case CREATE_DEMANDE_RF_BULK_REQUEST:
            return {
                ...state,
                error: null,
                message: null,
                lastBulkCreated: [],
            };

        case CREATE_DEMANDE_MANAGER_BULK_SUCCESS:
        case CREATE_DEMANDE_RF_BULK_SUCCESS:
            return {
                ...state,
                lastBulkCreated: Array.isArray(action.payload) ? action.payload : [],
                message: "Demandes bulk créées",
                error: null,
            };

        case CREATE_DEMANDE_MANAGER_BULK_FAIL:
        case CREATE_DEMANDE_RF_BULK_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur création demandes bulk",
                message: null,
            };

        // =====================
        // INBOX - MANAGER
        // =====================
        case GET_DEMANDE_MANAGER_INBOX_REQUEST:
        case GET_DEMANDES_MANAGER_CAMPAGNE_REQUEST:
            return {
                ...state,
                error: null,
                managerInbox: action.type === GET_DEMANDES_MANAGER_CAMPAGNE_REQUEST ? [] : state.managerInbox,
            };

        case GET_DEMANDE_MANAGER_INBOX_SUCCESS:
        case GET_DEMANDES_MANAGER_CAMPAGNE_SUCCESS:
            return {
                ...state,
                managerInbox: Array.isArray(action.payload) ? action.payload : [],
                error: null,
            };

        case GET_DEMANDE_MANAGER_INBOX_FAIL:
        case GET_DEMANDES_MANAGER_CAMPAGNE_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur chargement inbox manager",
                managerInbox: action.type === GET_DEMANDES_MANAGER_CAMPAGNE_FAIL ? [] : state.managerInbox,
            };

        // =====================
        // INBOX - RF
        // =====================
        case GET_DEMANDE_RF_INBOX_REQUEST:
        case GET_DEMANDES_CAMPAGNE_REQUEST:
            return {
                ...state,
                error: null,
                rfInbox: action.type === GET_DEMANDES_CAMPAGNE_REQUEST ? [] : state.rfInbox,
            };

        case GET_DEMANDE_RF_INBOX_SUCCESS:
        case GET_DEMANDES_CAMPAGNE_SUCCESS:
            return {
                ...state,
                rfInbox: Array.isArray(action.payload) ? action.payload : [],
                error: null,
            };

        case GET_DEMANDE_RF_INBOX_FAIL:
        case GET_DEMANDES_CAMPAGNE_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur chargement inbox RF",
                rfInbox: action.type === GET_DEMANDES_CAMPAGNE_FAIL ? [] : state.rfInbox,
            };

        // =====================
        // DECISIONS
        // =====================
        case DEMANDE_MANAGER_DECISION_REQUEST:
        case DEMANDE_RF_DECISION_REQUEST:
            return {
                ...state,
                error: null,
                message: null,
            };

        case DEMANDE_MANAGER_DECISION_SUCCESS:
            return {
                ...state,
                lastManagerDecision: action.payload || null,
                message: "Décision manager envoyée",
                error: null,
            };

        case DEMANDE_RF_DECISION_SUCCESS:
            return {
                ...state,
                lastRfDecision: action.payload || null,
                message: "Décision responsable formation envoyée",
                error: null,
            };

        case DEMANDE_MANAGER_DECISION_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur décision manager",
            };

        case DEMANDE_RF_DECISION_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur décision responsable formation",
            };

        default:
            return state;
    }
}
